export default {
  // 取得系統設定值
  getValue(parameters, code) {
    const target = parameters.find((parameter) => parameter.code === code);
    if (!target) return '';

    return target.value;
  },
};
